
import Home from '../home/home';
import Dashboard from '../dashboard/dashboard';
import About from '../about/about';
import Chartt from '../chartjs/chartt';
import styles from './layout.module.scss';

import {
    HashRouter as Router,
    Switch,
    Route,
    Link
  } from "react-router-dom";


function Layout(props:any) {


const selectMenu = (menuIndex:string)=>{ 
  
  const clonedState = Object.assign({},props.state);
  clonedState.selected = menuIndex
  props.stateChanger(clonedState);


}

  return (
    <Router>
    <div className={styles.containerheader}>

      <div className={styles.child}>
        <Link onClick={() => selectMenu('home')} className = {`${(props.state.selected === 'home') ? styles.nodecoactive : styles.nodeco}`} to="/">Home</Link>
      </div>
      <div className={styles.child}>
        <Link onClick={() => selectMenu('about')} className = {`${(props.state.selected === 'about') ? styles.nodecoactive : styles.nodeco}`} to="/about">About</Link>
      </div>
      <div className={styles.child}>
        <Link onClick={() => selectMenu('dashboard')} className = {`${(props.state.selected === 'dashboard') ? styles.nodecoactive : styles.nodeco}`} to="/dashboard">Dashboard</Link>
      </div>
      <div className={styles.child}>
        <Link onClick={() => selectMenu('charts')} className = {`${(props.state.selected === 'charts') ? styles.nodecoactive : styles.nodeco}`} to="/chart">Charts</Link>
      </div>
     
    </div>
    <Switch>
      <Route exact path="/">
        <Home />
      </Route>
      <Route path="/about">
        <About  state = {props.state} stateChanger ={props.stateChanger}/>
      </Route>
      <Route path="/dashboard">
        <Dashboard state = {props.state} stateChanger ={props.stateChanger} />
      </Route>
      <Route path="/chart">
        <Chartt state = {props.state} stateChanger ={props.stateChanger}/>
      </Route>


    </Switch>
  </Router>
  );
}


export default Layout;